module.exports = __webpack_public_path__ + "img/cowman.f1590993.png";